<template>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
    props: ['user','features','env'],
    data() {
        return {
        }
    },
    created() {
        this.storeUserSettings();
    },
    methods: {
        storeUserSettings() {
            window.vuexLoading = true;
            this.$store.commit('setUserDetails', this.user);
            this.$store.commit('setUserFeatures', this.features);
            this.$store.commit('setEnvironment', this.env)
            window.vuexLoading = false;
            /**set JWT for websocket auth */
            // window.socket.setJWT(this.user.jwt)
        }
    }
}
</script>
